import { StyleSheet } from 'react-native';

import { LAYOUT, THEME } from '../../reactor/common';

const { COLOR, UNIT } = THEME;

export default StyleSheet.create({
  container: StyleSheet.flatten([
    LAYOUT.STYLE.CENTERED,
    {
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: COLOR.WHITE,
      zIndex: 2,
      overflow: 'hidden',
    },
  ]),

  logo: {
    alignSelf: 'center',
    width: UNIT * 14.4,
    height: UNIT * 4.8,
  },

  progressBar: LAYOUT.STYLE.CENTERED,

  background: StyleSheet.flatten([
    LAYOUT.STYLE.CENTERED,
    {
      height: 0,
      width: '100%',
    },
  ]),

  text: {
    color: COLOR.WHITE,
    textAlign: 'center',
    width: '60%',
    alignSelf: 'center',
  },
});
